// @flow

import * as React from 'react';

import { Base, type BaseProps } from '@gandi/ui';
import { Main } from 'gandi.react-public-layout';

import styles from './HelpHeader.scss';

type Props = {|
  children: React.Node,
  // $FlowFixMe[incompatible-exact] Upgrade ui
  ...BaseProps,
|};

function HelpHeader({ children, ...props }: Props): React.Element<typeof Base> {
  return (
    <Base className={styles.root} {...props}>
      <Main className={styles.main}>{children}</Main>
    </Base>
  );
}

export default HelpHeader;
